/**
 * @graphql cc
 */
import gql from 'graphql-tag';

export const FeedTypeSelectorRefreshQuery = gql`
	query FeedTypeSelectorRefreshQuery {
		userPreferences {
			feedTab
		}
	}
`;
